module.exports = __webpack_public_path__ + "img/pic11.7be82ab9.jpg";